import { render, staticRenderFns } from "./Tokens.vue?vue&type=template&id=e89e0d7e&scoped=true&"
import script from "./Tokens.vue?vue&type=script&lang=js&"
export * from "./Tokens.vue?vue&type=script&lang=js&"
import style0 from "./Tokens.vue?vue&type=style&index=0&id=e89e0d7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89e0d7e",
  null
  
)

export default component.exports